import { render } from "./PageHeaderProducts.vue?vue&type=template&id=7e2c9156"
import script from "./PageHeaderProducts.vue?vue&type=script&lang=js"
export * from "./PageHeaderProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__